import React from "react";

function ViewFileArea(props) {
  console.log(props.uploadProgress)
  return (
    <div className={`${props.className} flex w-full`}>
      <div class={`flex items-center justify-center  w-full h-[16rem]`}>
        <label
          for="dropzone-file"
          class="flex flex-col col-span-2 items-center justify-center w-full h-full py-3 border-2 border-gray-300 border-dotted rounded-lg cursor-pointer hover:bg-light3"
        >
                {
                props.isLoading ? (
                  <div className="flex items-center justify-center">
                      <div className="w-8 h-8 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                  </div>
                ) :
                              
            (!props.files?.length ? (
              <>
                <div class="flex flex-row items-center justify-center gap-2 text-lg">
                  <img src="./icons/download.svg" />
                </div>
                <p class="text-md font-meidum text-grey-200">
                  Click to Upload {props.fileType ?? "(PDF, PNG and JPG)"}
                </p>
              </>
            ) : (
              <></>
            ))

        }

          <div className="flex flex-wrap w-full px-5 justify-start gap-4 mt-2">
            {props.files && props.files?.map((key, index) => {
              const id = `file_${index}`
              const isImage = props.files && props.files[index]?.split(".")?.length && typeof props.files[index] !== "object" && ["jpeg", "png", "svg", "jpg"].includes(props.files[index]?.split(".")[props.files[index]?.split(".").length - 1])
              return (
                <div className="h-[130px] w-[130px] relative  bg-light3">
                  <div className="relative h-[130px] w-[130px]">
                    <div className="absolute right-1 top-1">
                      <img
                        src="./icons/circleCross.svg"
                        className="h-[16px] w-[16px]"
                        onClick={(e) => {
                          e.preventDefault();
                          props.deleteFile(index);
                        }}
                      />
                    </div>
                    <img
                      src={isImage ? props.files[index] : "./icons/file.svg"}
                      className="bg-light3 justify-center items-center h-[130px] w-[130px]  object-cover px-auto rounded-md shadow-xs"
                    ></img>
                    <div className="absolute mx-5 mt-[-90px] font-medium text-center justify-center max-w-[100px] break-words">
                      {props.uploadProgress &&
                        props.uploadProgress[index]?.percentage && (
                          <progress
                            id={id}
                            value={props.uploadProgress[index]?.percentage}
                            max="100"
                            className="rounded-md bg-darkGrey w-[60px] h-[10px] "
                            style={{ borderRadius: "40px" }}
                          ></progress>
                        )}
                      <div className="text-darkGrey font-medium">
                        ...
                        {props.uploadProgress &&
                          props.uploadProgress[index]?.name
                            .slice(-15)}
                      </div>{" "}
                    </div>
                  </div>
                </div>
              );
            })}
            {props.files?.length && props.files?.length < (props.limit ?? 1)? <img src="/icons/add.svg"></img> : <></>}
          </div>

          <input id="dropzone-file" type="file" {...props} className="hidden" />
        </label>
      </div>
    </div>
  );
}

export default ViewFileArea;
